"use client";

import { useRef, useEffect, useState, useCallback, memo } from "react";
import { Button } from "./ui/button";
import { useRouter } from "next/navigation";
import { useSelector } from "react-redux";
import { setActiveTab } from "@/store/mainSlice";
import { cards } from "@/lib/dropDownData";
import { ChevronLeft, ChevronRight } from "lucide-react";
import Image from "next/image";
import { useDispatch } from "react-redux";
export const Greeting = ({
  type,
}: {
  type: "Page Builder" | "Card Maker" | "Business Plan" | "Chat";
}) => {
  console.log(type, "--typetype");
  const { activeTab } = useSelector((state) => state.main);
  const dispatch = useDispatch();
  const router = useRouter();
  // const [selected, setSelected] = useState(activeTab);
  const [selected, setSelected] = useState<string | null>(null);

  const [page, setPage] = useState(0);
  const cardRefs = useRef<{ [key: string]: HTMLLabelElement | null }>({});
  const scrollContainerRef = useRef<HTMLDivElement | null>(null);

  const cardsPerPage = 2;
  const totalPages = Math.ceil(cards.length / cardsPerPage);

  const handleClick = () => {
    router.push("/explore");
  };
  useEffect(() => {
    if (!activeTab && type) {
      dispatch(setActiveTab(type));
    }
  }, [activeTab, type, dispatch]);

  useEffect(() => {
    console.log(activeTab, "--greetingactiveTab", type);
    // if (isProjectPage && !activeTab) return;
    if (!activeTab) return;
    const matchedIndex = cards.findIndex(
      (c) => c.title.toLowerCase() === activeTab.toLowerCase(),
    );
    if (matchedIndex === -1) return;

    const matchedCard = cards[matchedIndex];
    const targetPage = Math.floor(matchedIndex / cardsPerPage);

    setSelected(matchedCard.id);
    setPage(targetPage);

    requestAnimationFrame(() => {
      const ref = cardRefs.current[matchedCard.id];
      const container = scrollContainerRef.current;
      if (!ref || !container) return;

      const cardRect = ref.getBoundingClientRect();
      const containerRect = container.getBoundingClientRect();
      const offsetLeft =
        cardRect.left - containerRect.left + container.scrollLeft;

      let targetScrollLeft =
        offsetLeft - container.clientWidth / 2 + cardRect.width / 2;

      const maxScrollLeft = container.scrollWidth - container.clientWidth;
      if (targetScrollLeft < 0) targetScrollLeft = 0;
      if (targetScrollLeft > maxScrollLeft) targetScrollLeft = maxScrollLeft;

      container.scrollTo({
        left: targetScrollLeft,
        behavior: "smooth",
      });
    });
  }, [activeTab, cards, cardsPerPage]);

  const handleSelect = (id: string) => {
    setSelected(id);

    const card = cards.find((c) => c.id === id);
    if (card) dispatch(setActiveTab(card.title));
  };
  const handlePrev = () => {
    if (page > 0) setPage((p) => p - 1);
  };

  const handleNext = () => {
    if (page < totalPages - 1) setPage((p) => p + 1);
  };

  const startIndex = page * cardsPerPage;
  const visibleCards = cards.slice(startIndex, startIndex + cardsPerPage);

  return (
    <div className=" flex flex-col justify-center  ">
      <div
        key="overview"
        className="max-w-4xl mx-auto px-8 w-full text-center space-y-3 mt-5"
      >
        {/* Logo */}
        <div className="flex justify-center mb-4">
          <div className="w-16 h-16 rounded-full bg-gray-200 dark:bg-[#1f1f1f] flex items-center justify-center border border-gray-300 dark:border-gray-700 shadow-md">
            <span className="text-lg font-semibold text-gray-700 dark:text-gray-300">
              {type === "Page Builder"
                ? "PB"
                : type === "Card Maker"
                  ? "CM"
                  : "BP"}
            </span>
          </div>
        </div>
        {type === "Card Maker" ? (
          <h1 className="text-pretty text-v0-gray-1000 text-center font-bold leading-[1.2] sm:text-[40px] lg:text-[40px] text-[28px] lg:mb-3 sm:mb-2 mb-1">
            Create Stunning Cards in Seconds
          </h1>
        ) : (
          <h1 className="text-pretty text-v0-gray-1000 text-center font-bold leading-[1.2] sm:text-[40px] lg:text-[40px] text-[28px] lg:mb-3 sm:mb-2 mb-1">
            Start Building your page
          </h1>
        )}
        {type === "Card Maker" ? (
          <h2 className="text-zinc-400 text-center sm:text-[16px] text-[14px] sm:whitespace-normal pb-4">
            Create your cards with a simple prompt — no design skills required.
          </h2>
        ) : (
          <h2 className="text-zinc-400 text-center sm:text-[16px] text-[14px] sm:whitespace-normal pb-4">
            Create your website with a simple text or voice prompt — no coding
            required.
          </h2>
        )}
        {/* Explore More Link */}
        {/* <button
            onClick={() => router.push("/explore-agents")}
            className=" inline-flex items-center gap-2 text-sm font-medium text-primary hover:underline pb-3"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
              className="w-4 h-4"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
            Explore more agents
          </button> */}
      </div>

      {/* <div ref={scrollContainerRef} className="overflow-x-auto no-scrollbar">
        <div className="flex justify-between gap-2 w-full w-[calc(100%+20px)]">
          <Button
            size="icon"
            variant="ghost"
            onClick={handlePrev}
            disabled={page === 0}
            className="h-8 w-8 rounded-full bg-accent hover:bg-transparent absolute top-[calc(50%+24px)] -left-[5px] -translate-y-[50%] z-[10]"
          >
            <ChevronLeft className="h-5 w-5" />
          </Button>
          <Button
            size="icon"
            variant="ghost"
            onClick={handleNext}
            disabled={page === totalPages - 1}
            className="h-8 w-8 rounded-full bg-accent hover:bg-transparent absolute top-[calc(50%+24px)] -right-[5px] -translate-y-[50%] z-[10]"
          >
            <ChevronRight className="h-5 w-5" />
          </Button>
        </div>
        <div className="flex flex-wrap gap-4 mt-8 justify-center">
          {visibleCards.map((card) => (
            <label
              key={card.id}
              ref={(el) => {
                cardRefs.current[card.id] = el;
              }}
              className={` lg:w-[calc(100%/2-16px/2-35px)] w-full p-3 rounded-xl border flex flex-col items-start cursor-pointer dark:border-white/30 border-[#e4e4e7] relative
            ${selected === card.id ? "bg-muted" : "bg-white dark:bg-black"} `}
            >
              <div className="flex items-center gap-3">
                <figure
                  className={`rounded-lg w-auto ${
                    selected === card.id ? "dark:bg-black/60" : "dark:bg-muted"
                  }  bg-black/10 p-2`}
                >
                  <svg
                    version="1.1"
                    viewBox="0 0 512 512"
                    className={`${card.iconColor} h-6 w-6`}
                  >
                    <g>
                      <path d="M0,0.002v511.996h512v-18.071V0.002H0z M475.859,475.856H36.141v-364.43h439.718V475.856z" />
                      <rect
                        x="78.305"
                        y="167.994"
                        width="355.386"
                        height="96.723"
                      />
                      <rect
                        x="295.152"
                        y="309.894"
                        width="138.538"
                        height="118.968"
                      />
                      <rect
                        x="78.305"
                        y="311.694"
                        width="162.631"
                        height="18.07"
                      />
                      <rect
                        x="78.305"
                        y="408.991"
                        width="162.631"
                        height="18.071"
                      />
                      <rect
                        x="78.305"
                        y="360.347"
                        width="162.631"
                        height="18.071"
                      />
                    </g>
                  </svg>
                </figure>
                <div className="block">
                  <h3 className="text-md font-semibold">{card.title}</h3>
                  <p className="text-[12px] dark:text-white/70 text-black/70">
                    {card.shortDesc}
                  </p>
                </div>
              </div>
              <p className="text-sm mt-2 dark:text-white/70 text-black/70">
                {card.description}
              </p>
              <input
                type="checkbox"
                checked={selected === card.id}
                onChange={() => handleSelect(card.id)}
                className="mt-2 accent-blue-500 absolute invisible pointer-events-none peer"
              />
              <span className="absolute top-[10px] right-[10px] border dark:border-white rounded-sm h-5 w-5 peer-checked:border-black dark:peer-checked:bg-white peer-checked:bg-black"></span>
              <span className="h-[6px] w-3 absolute top-[15.5px] right-[14px] border-b-[2px] border-l-[2px] dark:border-black border-white -rotate-[45deg] peer-checked:block hidden"></span>
            </label>
          ))}
        </div>
      </div> */}

      {/* <div className="relative w-full flex gap-2 rounded-2xl !text-base border py-4 dark:border-zinc-700 h-auto md:px-5 px-3 rounded-xl overflow-hidden overflow-y-auto my-4 md:pr-[70px] pr-[55px]">
        <figure className="h-7 w-7 block">
          <Image
            src="/images/sparkles.png"
            alt="Sparkle"
            width={20}
            height={28}
            className="w-full h-full object-contain"
          />
        </figure>
        <div className="flex-1">
          <h3 className="font-semibold text-sm">Explore</h3>
          <p className="text-sm dark:text-white/70 text-black/70">
            {type === "Page Builder"
              ? "See examples of websites you can create with Varnz.AI."
              : "See examples of beautiful cards you can create with Varnz.AI."}
          </p>
        </div>
        <button
          onClick={handleClick}
          className="h-9 w-9 border rounded-full flex items-center justify-center absolute top-[50%] md:right-5 right-3 -translate-y-[50%] p-2 hover:bg-muted"
        >
          <svg
            height="14"
            strokeLinejoin="round"
            viewBox="0 0 16 16"
            width="14"
            style={{ color: "currentColor" }}
            className="rotate-[45deg] w-full h-full"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M8.70711 1.39644C8.31659 1.00592 7.68342 1.00592 7.2929 1.39644L2.21968 6.46966L1.68935 6.99999L2.75001 8.06065L3.28034 7.53032L7.25001 3.56065V14.25V15H8.75001V14.25V3.56065L12.7197 7.53032L13.25 8.06065L14.3107 6.99999L13.7803 6.46966L8.70711 1.39644Z"
              fill="currentColor"
            ></path>
          </svg>
        </button>
      </div> */}
    </div>
  );
};
